<script lang="ts">

  import FacebookIcon from '../icons/FacebookIcon.svelte';
  import TwitterIcon from '../icons/TwitterIcon.svelte';
  import LinkedInIcon from '../icons/LinkedInIcon.svelte';
  import LinkIcon from '../icons/LinkIcon.svelte';
  import EmailIcon from '../icons/EmailIcon.svelte';
  import * as t from '../translations/News.ts';

  const iconColor = 'var(--vv-black)';

  export let shareTitle: string = '';
  export let shareUrl: string | undefined;
  export let type: 'blog' | undefined;
  export let id: string | number | undefined;

  $: actualShareUrl = shareUrl;
  if (!actualShareUrl && type === 'blog' && id) {
    actualShareUrl = `/news/blog/${id}`;
  }
  if (!actualShareUrl) {
    if (typeof window !== 'undefined') {
      actualShareUrl = window.location.pathname + window.location.hash;
    } else {
      actualShareUrl = '';
    }
  }

  $: absoluteShareUrl = actualShareUrl.startsWith('http')
    ? actualShareUrl
    : `https://www.votervoice.net${actualShareUrl}`;

  $: facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(absoluteShareUrl)}`;
  $: twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(absoluteShareUrl)}&text=${encodeURIComponent(shareTitle)}`;
  $: linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(absoluteShareUrl)}&title=${encodeURIComponent(shareTitle)}`;

  let copied = false;
  async function handleCopyLink() {
    await navigator.clipboard.writeText(absoluteShareUrl);
    copied = true;
    setTimeout(() => { copied = false; }, 1500);
  }

  $: mailtoSubject = shareTitle ? `Check this out: ${shareTitle}` : 'Check this out!';
  $: mailtoBody = `I thought you might find this interesting: ${absoluteShareUrl}`;
  $: mailtoLink = `mailto:?subject=${encodeURIComponent(mailtoSubject)}&body=${encodeURIComponent(mailtoBody)}`;
</script>

<div class="mt-10 flex flex-col items-start md:items-end" data-testid="share-section">
  <div class="flex items-center gap-2 md:gap-3" data-testid="share-buttons-row">
    <span class="text-base font-medium">{t.Share_Label()}</span>

    <!-- Facebook -->
    <a
      href={facebookUrl}
      target="_blank"
      rel="noopener"
      aria-label="Share on Facebook"
      class="inline-flex items-center justify-center text-black w-8 h-8 transition-transform duration-150 ease-in-out hover:scale-110"
      data-testid="share-facebook"
    >
      <FacebookIcon color={iconColor} />
    </a>

    <!-- Twitter/X -->
    <a
      href={twitterUrl}
      target="_blank"
      rel="noopener"
      aria-label="Share on X (Twitter)"
      class="inline-flex items-center justify-center text-black w-8 h-8 transition-transform duration-150 ease-in-out hover:scale-110"
      data-testid="share-twitter"
    >
      <TwitterIcon color={iconColor} />
    </a>

    <!-- LinkedIn -->
    <a
      href={linkedinUrl}
      target="_blank"
      rel="noopener"
      aria-label="Share on LinkedIn"
      class="inline-flex items-center justify-center text-black w-8 h-8 transition-transform duration-150 ease-in-out hover:scale-110"
      data-testid="share-linkedin"
    >
      <LinkedInIcon color={iconColor} />
    </a>

    <!-- Email -->
    <a
      href={mailtoLink}
      aria-label="Share via Email"
      class="inline-flex items-center justify-center text-black w-8 h-8 transition-transform duration-150 ease-in-out hover:scale-110"
      data-testid="share-email"
    >
      <EmailIcon color={iconColor} />
    </a>

    <!-- Copy Link -->
    <div class="relative flex flex-col items-center justify-center" data-testid="copy-link-container">
      <button
        class="inline-flex items-center justify-center text-black w-8 h-8 transition-transform duration-150 ease-in-out hover:scale-110"
        on:click={handleCopyLink}
        aria-label="Copy Link"
        data-testid="copy-link-btn"
      >
        <LinkIcon color={iconColor} />
      </button>
      {#if copied}
        <span class="absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-1 rounded bg-white text-green-500 text-xs shadow border border-green-200" data-testid="copied-popup">Copied!</span>
      {/if}
    </div>
  </div>
</div>